"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import { GroupedCardCarouselProps } from "./types";
import CasesCard from "../CasesCard";
import { CasesCardProps } from "../CasesCard";

const chunkCards = (arr: CasesCardProps[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const GroupedCardCarousel = ({
  className,
  cards,
}: GroupedCardCarouselProps) => {
  const cardChunks = chunkCards(cards, 4);
  return (
    <Carousel.Mobile
      options={{
        slides: {
          spacing: 24,
          perView: "auto",
        },
      }}
      showPagination
      className={cn(
        "md:flex md:flex-wrap md:justify-center md:-m-2 md:!overflow-visible",
        className
      )}
    >
      {cardChunks.map((chunk, chunkIndex) => (
        <CarouselSlide
          key={`chunk-${chunkIndex}`}
          className="!min-w-full !w-full !md:min-w-auto md:!w-auto grid grid-cols-1 place-content-start gap-4 md:!contents md:!gap-0"
        >
          {chunk.map(({ title, description, linkLabel, imageUrl, link }, i) => (
            <div className="md:flex md:p-2 md:w-full md:max-w-[33.33%] lg:max-w-[25%]" key={i}>
              <CasesCard
                title={title}
                imageUrl={imageUrl}
                description={description}
                link={link}
                linkLabel={linkLabel}
                responsive
                className="md:flex-auto md:min-w-0"
              />
            </div>
          ))}
        </CarouselSlide>
      ))}
    </Carousel.Mobile>
  );
};

export default memo(GroupedCardCarousel);
